import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { fetchData, postData, putData, updateData, deleteData, activateData } from '../../../apiService'; // Assuming putData is used for updating
import { Card, CardContent, TableContainer, Paper, Tooltip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from '@mui/material';
import Select from 'react-select';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Link } from 'react-router-dom';
import CancelIcon from '@mui/icons-material/Cancel';
import UndoIcon from '@mui/icons-material/Undo';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';

const SaleReturnApprovalEdit = () => {
    const { id, tid } = useParams();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, userId, token, logout } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
        }
    }, [isAuthenticated, token, logout]);
    const [isGstTable, setIsGstTable] = useState(1); // Default value is 0 for GST
    const [DateInvoice, setDateInvoice] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [TripId, setTripId] = useState('');
    const [SaleId, setSaleId] = useState('');
    const [qty, setQty] = useState('');
    const [successMessages, setSuccessMessages] = useState("");
    const [errorMessages, setErrorMessages] = useState("");
    const [selectedItem, setSelectedItem] = useState(null);
    const [saleData, setSaleData] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [itemnameget, setItemName] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [quantities, setQuantities] = useState([]);
    const [searchDate, setSearchDate] = useState('');
    const [filteredSaleData, setFilteredSaleData] = useState([]);
    const [selectedInvoices, setSelectedInvoices] = useState([]);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [getDate, setGetData] = useState([]);
    const [selectedCustomerType, setSelectedCustomerType] = useState("");
    const [RQuantities, setRQuantities] = useState([]);
    const [RateAfterDis, setRateAfterDis] = useState([]);
    const [RouteName, setRouteName] = useState('');
    const [remark, setRemark] = useState("");
    const [currentDisplayedDate, setCurrentDisplayedDate] = useState(null);
    const [showSelectedInvoice, setShowSelectedInvoice] = useState(false);
    const [gst, setgst] = useState(Array(5).fill('0.00')); // Initialize with "0.00"
    const [Amount, setAmount] = useState([]);
    const [ReturnId, setReturnIdId] = useState(null);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [searchQuery, setSearchQuery] = useState(""); // State for search query
    const [formData, setFormData] = useState({
        datas: {
            CustomerId: '',
            CustomerName: '',
            Remark: '',
            RQuantity: '',
        }
    });
    const [getDatesale, setGetDatasale] = useState({
        datas: {
            RQuantity: '',
        }
    });

    useEffect(() => {
        fetchSaleReturnData();
    }, []);

    useEffect(() => {
        fetchtableData();
    }, []);

    // customer name
    const fetchtableData = async () => {
        fetchData('CustomerApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    const options = response.response_data.map(customer => ({
                        value: customer.id,
                        label: customer.name+ ' ' +customer.AddressLine1 + ' ' +customer.CustomerCode,
                    }));
                    setCustomerOptions(options);
                }
            })
            .catch((error) => {
                console.error('Error fetching customer Details:', error);
            });
    };

    const handleCustomerChange = (selectedOption) => {
        setSelectedCustomerType(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            CustomerId: selectedOption ? selectedOption.value : null,
        }));

    };

    const fetchSaleReturnData = async () => {
        try {
            const response = await fetchData('SaleReturnApprovalAPI', `/SaleReturnCustomer/${id}`, token);
            if (response.responseCode === '1111') {
                setFormData(response.response_data);
                const array = response.response_data;
                console.log(response);
                const selectedcustomerOption = customerOptions.find(option => option.value === response.response_data.CustomerId);
                setSelectedCustomerType(selectedcustomerOption);
                setCustomerId(response.response_data.CustomerId)
                setRouteName(response.response_data.Route)

            }
        } catch (error) {
            console.error('Error fetching sale return data:', error);
        }
    };

    const handleChange = event => {
        const { name, value } = event.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };

    //invoice date
    const handleCustomerTypeChange = async () => {
        const response = await fetchData('SaleReturnApi', `/${companyId}/${customerId}`, token);
        if (response.responseCode === '1111') {
            const sortedData = response.response_data.sort((a, b) => new Date(b.invoiceDate) - new Date(a.invoiceDate));
            setSaleData(sortedData);
            setFilteredSaleData(sortedData);
            setQuantities(new Array(sortedData.length).fill(''));
            setShowModal(true);
        }
    };

    const handleRefreshClick = () => {
        window.location.reload();
    };

    useEffect(() => {
        fetchtableReturnData();
    }, []);

    /////////table data
    const fetchtableReturnData = async () => {
        try {
            const response = await fetchData('SaleReturnApprovalAPI', `/SaleReturn/${id}`, token);
            if (response.responseCode === '1111') {
                const dataArray = response.response_data;
                setGetData(response.response_data);
                setGetDatasale(response.response_data);
                setReturnIdId(response.response_data.map(item => item.ID));
                setDateInvoice(dataArray[0].invoiceDate);
                console.log(response);
                setRQuantities(response.response_data.map(item => item.RQuantity));
                setRateAfterDis(response.response_data.map(item => item.RateAfterDiscount));
            }
        } catch (error) {
            console.error('Error fetching sale return data:', error);
        }
    };

    const returnDate = getDate.length > 0 ? getDate[0].ReturnDate : "";
    //  total amount
    const truncate2 = (num) => Math.trunc(num * 100) / 100;

    // calculation {gst, taxable values...........}
    function calculateTotalAmount(rateAfterDiscount, gstrate, quantities, bagweight) {
        if (isGstTable === 1) {
            gstrate = gstrate || 0;
            const totalQty = quantities * bagweight;
            const taxableAmount = truncate2(rateAfterDiscount * totalQty * 100 / (100 + gstrate));
            const cgstAmount = truncate2(taxableAmount * gstrate / (2 * 100));
            const sgstAmount = truncate2(taxableAmount * gstrate / (2 * 100));
            const igstAmount = 0;
            const totalAmount = taxableAmount + cgstAmount + sgstAmount + igstAmount;
            return isNaN(totalAmount) ? 0 : Math.round(totalAmount);
        }
        else {
            gstrate = 0;
            const totalQty = quantities * bagweight;
            const taxableAmount = truncate2(rateAfterDiscount * totalQty * 100 / (100 + gstrate));
            const cgstAmount = truncate2(taxableAmount * gstrate / (2 * 100));
            const sgstAmount = truncate2(taxableAmount * gstrate / (2 * 100));
            const igstAmount = 0;
            const totalAmount = taxableAmount + cgstAmount + sgstAmount + igstAmount;
            return isNaN(totalAmount) ? 0 : Math.round(totalAmount);
        }
    }

    function calculateGst(rapeperpeice, gstrate, quantities, bagweight) {
        const cgstAmount = calculateCGST(rapeperpeice, gstrate, quantities, bagweight);
        const sgstAmount = calculateSGST(rapeperpeice, gstrate, quantities, bagweight);
        const igstAmount = 0;
        const gst = cgstAmount + sgstAmount + igstAmount;
        return isNaN(gst) ? 0 : truncate2(gst).toFixed(2);
    }

    function calculateCGST(rateAfterDiscount, gstrate, quantities, bagweight) {
        if (isGstTable === 1) {
            gstrate = gstrate || 0;
            const totalQty = quantities * bagweight;
            const taxableAmount = truncate2(rateAfterDiscount * totalQty * 100 / (100 + gstrate));
            const cgstAmount = truncate2(taxableAmount * gstrate / (2 * 100));
            return cgstAmount;
        }
        else {
            gstrate = 0;
            const totalQty = quantities * bagweight;
            const taxableAmount = truncate2(rateAfterDiscount * totalQty * 100 / (100 + gstrate));
            const cgstAmount = truncate2(taxableAmount * gstrate / (2 * 100));
            return cgstAmount;
        }
    }

    function calculateSGST(rateAfterDiscount, gstrate, quantities, bagweight) {
        if (isGstTable === 1) {
            gstrate = gstrate || 0;
            const totalQty = quantities * bagweight;
            const taxableAmount = truncate2(rateAfterDiscount * totalQty * 100 / (100 + gstrate));
            const sgstAmount = truncate2(taxableAmount * gstrate / (2 * 100));
            return sgstAmount;
        }
        else {
            gstrate = 0;
            const totalQty = quantities * bagweight;
            const taxableAmount = truncate2(rateAfterDiscount * totalQty * 100 / (100 + gstrate));
            const sgstAmount = truncate2(taxableAmount * gstrate / (2 * 100));
            return sgstAmount;
        }
    }

    function taxableAmount(rateAfterDiscount, gstrate, quantities, bagweight) {
        if (isGstTable === 1) {
            gstrate = gstrate || 0;
            const totalQty = quantities * bagweight;
            const taxableAmount = truncate2(rateAfterDiscount * totalQty * 100 / (100 + gstrate));
            return isNaN(taxableAmount) ? 0 : taxableAmount.toFixed(2);
        }
        else {
            gstrate = 0;
            const totalQty = quantities * bagweight;
            const taxableAmount = truncate2(rateAfterDiscount * totalQty * 100 / (100 + gstrate));
            return isNaN(taxableAmount) ? 0 : taxableAmount.toFixed(2);
        }

    }


    // amount validation
    const handleAmountChange = (e, index) => {
        const value = e.target.value;
        const regex = /^\d*\.?\d*$/;
        if ((regex.test(value) && value.length <= 7) || value === '') {
            const newAmount = [...RateAfterDis];
            newAmount[index] = value;
            setRateAfterDis(newAmount);
        }
    };
    const handleRQuantityChange = (index, value) => {
        const updatedQuantities = [...RQuantities];
        updatedQuantities[index] = value;
        setRQuantities(updatedQuantities);
    };
    const closeModal = () => {
        setShowModal(false);
    };

    //invoice date model
    const handleInvoiceButton = () => {
        handleCustomerTypeChange();
        setShowModal(true);
    };

    const combinedInvoiceData = selectedInvoices.flatMap(invoice => invoice.data);

    // fetch already exist data
    const handleInvoiceClick = async (invoice) => {
        try {
            const isSelected = selectedInvoices.some(inv => inv.id === invoice.id);
            if (isSelected) {
                setSelectedInvoices(prevInvoices => prevInvoices.filter(inv => inv.id !== invoice.id));
                setGetData(prevGetData => prevGetData.filter(item => item.invoiceId !== invoice.id));
                setGetDatasale(prevGetDatasale => prevGetDatasale.filter(item => item.invoiceId !== invoice.id));
                setDateInvoice(null);
                setRQuantities([]);
                setRateAfterDis([]);
                setShowSelectedInvoice(false);
            } else {
                const saleReturnApiResponse = await fetchData('SaleReturnApi', `/SaleReturn/${invoice.id}`, token);
                if (saleReturnApiResponse.responseCode === '1111') {
                    const saleReturnData = saleReturnApiResponse.response_data;
                    setGetData(prevGetData => [...prevGetData, ...saleReturnData]);
                    setDateInvoice(saleReturnData.length > 0 ? saleReturnData[0].invoiceDate : null); // Update date for new invoice data
                    setRQuantities(prevRQuantities => [...prevRQuantities, ...saleReturnData.map(item => item.RQuantity)]);
                    setRateAfterDis(prevRate => [...prevRate, ...saleReturnData.map(item => item.RateAfterDiscount)]);
                }

                const returnSaleOrderApiResponse = await fetchData('SaleReturnApprovalAPI', `/SaleReturn/${invoice.id}`, token);
                if (returnSaleOrderApiResponse.responseCode === '1111') {
                    const returnSaleOrderData = returnSaleOrderApiResponse.response_data;

                    setGetDatasale(prevGetDatasale => [...prevGetDatasale, ...returnSaleOrderData]);
                }

                setCurrentDisplayedDate(invoice.invoiceDate);
                setSelectedInvoices(prevInvoices => [...prevInvoices, invoice]);
                setShowSelectedInvoice(true);
            }
        } catch (error) {
            console.error('Error fetching invoice data:', error);
        }
    };
    // search invoice date
    const handleSearch = () => {
        const filteredData = saleData.filter(item => {
            const invoiceDate = new Date(item.invoiceDate).toLocaleDateString('en-GB');
            return invoiceDate.includes(searchDate);
        });
        setFilteredSaleData(filteredData);
    };

    const [approvalStatus, setApprovalStatus] = useState(new Array(getDate.length).fill(false));
    const [rejectionStatus, setRejectionStatus] = useState(new Array(getDate.length).fill(false));

    const handleApprovalClick = (index) => {
        const newApprovalStatus = [...approvalStatus];
        const newRejectionStatus = [...rejectionStatus];
        newApprovalStatus[index] = true;
        newRejectionStatus[index] = false;
        setApprovalStatus(newApprovalStatus);
        setRejectionStatus(newRejectionStatus);
    };

    const handleRejectClick = (index) => {
        const newApprovalStatus = [...approvalStatus];
        const newRejectionStatus = [...rejectionStatus];
        newApprovalStatus[index] = false;
        newRejectionStatus[index] = true;
        setApprovalStatus(newApprovalStatus);
        setRejectionStatus(newRejectionStatus);
    };


    const handleGstClick = () => {
        setIsGstTable(1); // GST button clicked
    };

    const handleNonGstClick = () => {
        setIsGstTable(0); // Non-GST button clicked
    };
    const submitData = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        // Validation for multiple row
        let isValid = true;
        getDate.forEach((item, index) => {
            if (!RateAfterDis[index] || RateAfterDis[index].length === 0 || RateAfterDis.some(amount => amount === undefined || RateAfterDis[index] <= 0)) {
                isValid = false;
            }
        });

        if (!isValid) {
            alert('Please Enter Return Rate For All Items❗.');
            setIsLoading(false);
            return;
        }

      


        let isValidStatus = true;
        getDate.forEach((item, index) => {
            if (!approvalStatus[index] && !rejectionStatus[index]) {
                isValidStatus = false;
            }
        });

        if (!isValidStatus) {
            alert('Please Click Approval ✅ or Reject ❌ Icon for all items.');
            setIsLoading(false);
            return;
        }


        const SaleReturnApproval = {
            Id: id,
            CustomerId: customerId,
            ModifiedBy: userId,
            ModifiedDate: new Date(),
            Remark: formData.Remark,
            IsGST: isGstTable === 1 ? true : false,
            ItemName: getDate.find(item => item.ItemId === SaleId)?.ItemName || 'Unknown',
        };

        const SaleReturnApprovalDetails = [];

        RQuantities.forEach((qty, index) => {
            if (qty && qty > 0) {
                const item = getDate[index];
                const gst = calculateGst(RateAfterDis[index], item.GSTRate, qty, item.Bagweight);



                SaleReturnApprovalDetails.push({
                    CustomerId: customerId,
                    CompanyId: companyId,
                    RQuantity: parseInt(qty), // Assuming RQuantities is defined elsewhere
                    UpdatedBy: userId,
                    UpdatedDate: new Date(),
                    Item: item.ItemName,
                    ItemId: item.ItemId,
                    RRate: parseInt(RateAfterDis[index]) * item.Bagweight * parseInt(qty),
                    GSTRate: item.GSTRate,
                    ItemName: item.ItemName,
                    IsApproved: Boolean(approvalStatus[index]),
                    IsRejected: Boolean(rejectionStatus[index]),
                    Bagweight: item.Bagweight,
                    RateperKg: (RateAfterDis[index]),
                    IsGST: isGstTable === 1 ? true : false,  // Ensure IsGST is a boolean value
                    GST: parseFloat(gst),
                });
            }
        });

        const CreateData = {
            SaleReturn: SaleReturnApproval,
            SaleReturnDetails: SaleReturnApprovalDetails,
        };

        try {
            const response = await updateData('SaleReturnApprovalAPI', `${id}`, CreateData, token);
            console.log('Sale Return success:', response);
            setQuantities(Array(getDate.length).fill(""));
            setSuccessMessages("Sale Return successfully!");
            setErrorMessages("");
            history.push('/SaleReturnApprovalIndex');
            setTimeout(() => {
                setSuccessMessages("");
            }, 3000);

        } catch (error) {
            console.error('Sale Return error:', error);
            setIsLoading(false);
        }
    };
    //scroll

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: state.isDisabled ? '#f0f0f0' : provided.backgroundColor,
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: state.isDisabled ? '#000' : provided.color,
        }),
        placeholder: (provided, state) => ({
            ...provided,
            color: state.isDisabled ? '#000' : provided.color,
        }),
    };

    return (
        <div className="container w-full max-w-sm container mt-2 mx-auto" style={{ maxHeight: '730px', overflow: 'auto', maxWidth: '100%' }}>

            <div style={{ maxWidth: '100%' }}>
                <div style={{ backgroundColor: 'rgba(255, 255, 255, 0)', maxWidth: '100%' }}>
                    <CardContent>
                        {/* <div>
                            <h4 className="block uppercase text-lg font-semibold mb-4 linkcolor mr-2" 
                            style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'brown' }}>Sale Return & Approval</h4>
                        </div>
                        <div style={{ marginTop: '-47px' }} >
                            <h5 style={{ marginLeft: '45%', color: '#02395E', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Route: {RouteName}</h5>
                        </div> */}
                        <div>
                            <h6 className="uppercase tracking-wide text-black flex-grow linkcolor"
                                style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'brown' }}>Sale Return & Approval</h6>
                        </div>
                        <div style={{ marginTop: '-35px', marginLeft: '45%' }}>
                            <h6 className="uppercase tracking-wide text-brown flex-grow linkcolor"
                                style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'brown' }}>Route : {RouteName}</h6>
                        </div>
                        <div className="flex mb-2" style={{ justifyContent: "flex-end", marginRight: '20px', marginTop: '-35px' }}>
                            <Tooltip title="Exit">
                                <Link to={`/SaleReturnApprovalIndex`} style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                <Button variant="contained" color="error" style={{ marginLeft: '10px' }}>
                                        Back
                                    </Button>
                                </Link>
                            </Tooltip>
                            &nbsp;&nbsp;


                            <Tooltip title="Refresh">
                                <Button onClick={handleRefreshClick}
                                 style={{ marginLeft: '8px', backgroundColor: 'yellow', color: 'black', fontWeight: 'bolder' }}>
                                    Refresh  </Button>
                            </Tooltip>

                            {/* <Link to={`/SaleReturnApprovalIndex`}>
                                <Button style={{ background: '#FF004F', fontWeight: 'bolder', color: 'white' }} >
                                    <UndoIcon style={{ fontWeight: 'bolder' }} />  Cancel</Button>
                            </Link> */}
                            &nbsp;&nbsp;

                            <Button onClick={submitData} style={{ background: '#7FFFD4', color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "Update"} 
                            </Button>

                        </div>

                        <div className='w-full mb-2' style={{ display: 'flex', flexWrap: 'wrap' }}>
                            <div className="w-1/2 mr-2">
                            <label className="block uppercase tracking-wide  text-black font-bold mb-2" htmlFor="name">
                                    Customer
                                </label>
                                {/* <Select
                                  value={selectedCustomerType || (formData.CustomerName   +formData.AddressLine1?{value: formData.CustomerName   +formData.AddressLine1, label: formData.CustomerName   +formData.AddressLine1 } : '')}
                                    onChange={handleCustomerChange}
                                    options={customerOptions}
                                    placeholder="Customer"
                                    styles={customStyles}
                                    isSearchable
                                    isDisabled={true}
                                /> */}
                                
                                <Select
                                    value={
                                        selectedCustomerType ||
                                        (formData.CustomerName && formData.AddressLine1 && formData.CustomerCode
                                            ? {
                                                value: `${formData.CustomerName} ${formData.AddressLine1} ${formData.CustomerCode}`,
                                                label: `${formData.CustomerName} ${formData.AddressLine1} ${formData.CustomerCode}`
                                            }
                                            : '')
                                    }
                                    onChange={handleCustomerChange}
                                    options={customerOptions}
                                    placeholder="Customer"
                                    styles={customStyles}
                                    isSearchable
                                    isDisabled
                                />
                            </div>
                            <div className="w-1/3 mr-2" style={{ marginLeft: '1%' }}>
                            <label className="block uppercase tracking-wide  text-black font-bold mb-2" htmlFor="name">
                                    Remark
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline ml-2"
                                    name="Remark"
                                    value={formData.Remark}
                                    maxLength="100"
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter Remark"
                                />
                            </div>
                            {returnDate && (
                                <div className="w-1/3 mr-2" style={{ marginLeft: '4%', marginTop: '38px' }}>
                                    <h5 className='productHead flex-grow linkcolor' >
                                        <span style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: '#954535', fontSize:'16px' }}>
                                            Return Date:
                                        </span>
                                        <span style={{ marginLeft: '5px', color: '#954535' , fontSize:'16px'}}>
                                            {returnDate && new Date(returnDate).toLocaleDateString('en-GB')}
                                        </span>
                                    </h5>
                                </div>
                            )}

                            <div className="w-1/3 mr-2" style={{ marginLeft: '79%', marginTop: '-42px' }}>
                                <button
                                    onClick={handleGstClick}
                                    style={{
                                        backgroundColor: isGstTable === 1 ? 'blue' : 'gray',
                                        color: 'white',
                                      
                                        padding: '5px 20px',
                                        marginRight: '10px',
                                        cursor: 'pointer',
                                        border: 'none',
                                        borderRadius: '4px'
                                    }}
                                >
                                    GST
                                </button>
                                <button
                                    onClick={handleNonGstClick}
                                    style={{
                                        backgroundColor: isGstTable === 0 ? 'blue' : 'gray',
                                        color: 'white',
                                      
                                        padding: '5px 20px',
                                        cursor: 'pointer',
                                        border: 'none',
                                        borderRadius: '4px'
                                    }}
                                >
                                    ESTIMATE BILL
                                </button>
                            </div>

                        </div>

                        <div className="w-full mb-4 flex">
                            <TableContainer component={Paper}>
                                <div style={{ maxHeight: '400px', overflowY: 'auto', maxWidth: '100%' }}>

                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Sl.No</th>
                                                <Tooltip title="Item Name"><th>Name</th></Tooltip>
                                                <Tooltip title="Bag Weight"><th>Bag Weight</th></Tooltip>
                                                <th>GST %</th>
                                                <Tooltip title="Return Quantity"><th>R.Qty <p style={{ fontSize: '10px', marginBlock: '-7px', fontFamily: ' Times New Roman", Times, serif' }}>(No.of pieces)</p></th></Tooltip>
                                                <Tooltip title="Rate Per Kg"><th>Rate/Kg <p style={{ fontSize: '10px', marginBlock: '-7px', fontFamily: ' Times New Roman", Times, serif' }}>(Including Tax)</p></th></Tooltip>
                                                <Tooltip title="Return Rate Per Kg"><th>R.Rate/Kg <p style={{ fontSize: '10px', marginBlock: '-7px', fontFamily: ' Times New Roman", Times, serif' }}>(Including Tax)</p></th></Tooltip>
                                                <Tooltip title="Total Quantity"><th>Total Qty
                                                    <p style={{ fontSize: '10px', marginBlock: '-7px', fontFamily: ' Times New Roman", Times, serif' }}>(KGS)</p></th></Tooltip>
                                                <Tooltip title="Taxable Amount"><th>Taxable Amt</th></Tooltip>
                                                <th>GST</th>
                                                <Tooltip title="Net Amount"><th>Net Amt</th></Tooltip>
                                                <th style={{ width: '100px' }}></th>

                                            </tr>
                                        </thead>

                                        <tbody>

                                            {getDate.map((item, index) => (
                                                <tr key={index}>
                                                    <td className="border-r" >{index + 1}</td>
                                                    <td className="border-r">{item.ItemName}</td>
                                                    <td className="border-r" style={{ textAlign: 'right' }}>{item.Bagweight}</td>
                                                    {/* <td className="border-r" style={{ textAlign: 'right' }}>{item.GSTRate} </td> */}
                                                    <td className="border-r" style={{ textAlign: 'right' }}>
                                                        {isGstTable === 0 ? 0 : item.GSTRate}
                                                    </td>
                                                    <td className="border-r" style={{ width: '100px', textAlign: 'right' }}>
                                                        <input
                                                            name="RQuantity"
                                                            value={RQuantities[index] || ''}
                                                            style={{ backgroundColor: RQuantities[index] > 0 ? '#FFD6D1' : 'inherit', width: '100px', textAlign: 'right' }}
                                                            onChange={(e) => {
                                                                const input = e.target.value.replace(/\D/g, '');
                                                                if (input.length <= 4) {
                                                                    const newQuantity = parseInt(input, 10);
                                                                    //if (newQuantity <= item.Quantity || input === '') {
                                                                    handleRQuantityChange(index, input);
                                                                    // } else {
                                                                    //     if (input !== '') {
                                                                    //         alert(`⚠️ Return Quantity should be less than Sale Quantity!`);
                                                                    //     }
                                                                    // }
                                                                }
                                                            }}
                                                            type="text"
                                                            min="0"
                                                            autoComplete="off"
                                                        />
                                                    </td>
                                                    <td className="border-r" style={{ textAlign: 'right' }}>{item.SRate}</td>
                                                    <td className="border-r" style={{ width: '100px', textAlign: 'right' }}>
                                                        <input
                                                            name="RateAfterDiscount"
                                                            value={RateAfterDis[index] || ''}
                                                            style={{ backgroundColor: RateAfterDis[index] > 0 ? '#FFD6D1' : 'inherit', width: '100px', textAlign: 'right' }}
                                                            onChange={(e) => handleAmountChange(e, index)}
                                                            type="text"
                                                            min="0"
                                                            autoComplete="off"
                                                        />

                                                    </td>
                                                    <td className="border-r" style={{ textAlign: 'right' }}>{isNaN(item.Bagweight * RQuantities[index]) ? '0.00' : (item.Bagweight * RQuantities[index])}</td>
                                                    <td className="border-r" style={{ textAlign: 'right' }}>{isNaN(taxableAmount(RateAfterDis[index], item.GSTRate, RQuantities[index], item.Bagweight)) ? '0.00' : taxableAmount(RateAfterDis[index], item.GSTRate, RQuantities[index], item.Bagweight)}</td>
                                                    <td className="border-r" style={{ textAlign: 'right' }}>{calculateGst(RateAfterDis[index], item.GSTRate, RQuantities[index], item.Bagweight)}</td>
                                                    <td className="border-r" style={{ textAlign: 'right' }}>{isNaN(calculateTotalAmount(RateAfterDis[index], item.GSTRate, RQuantities[index], item.Bagweight)) ? '0.00' : calculateTotalAmount(RateAfterDis[index], item.GSTRate, RQuantities[index], item.Bagweight)}</td>
                                                    <td className="border-r" style={{ textAlign: 'right', width: '100px' }}>

                                                        <Tooltip title="Approval">
                                                            <span onClick={() => handleApprovalClick(index)} style={{ cursor: isLoading ? 'default' : 'pointer' }}>
                                                                <CheckCircleIcon style={{ color: approvalStatus[index] ? '#32CD32' : 'gray', fontWeight: 'bolder' }} />
                                                            </span>
                                                        </Tooltip>
                                                        <span>&nbsp;&nbsp;</span>
                                                        <Tooltip title="Reject">
                                                            <span onClick={() => handleRejectClick(index)} style={{ cursor: isLoading ? 'default' : 'pointer' }}>
                                                                <CancelIcon style={{ color: rejectionStatus[index] ? 'red' : 'gray', fontWeight: 'bolder' }} />
                                                            </span>
                                                        </Tooltip>
                                                       

                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot>
                                            <tr >
                                                <td className="border-r text-left text-sm " colSpan="2" style={{ backgroundColor: 'rgb(190 242 225)' }}>Total</td>
                                                <td className="px-4 py-2 border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>{getDate.reduce((acc, item) => acc + item.Bagweight, 0)}</td>
                                                <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>{getDate.reduce((acc, item) => acc + item.GSTRate, 0)}</td>

                                                <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>
                                                    {getDate.reduce((acc, item, idx) => acc + (parseInt(RQuantities[idx]) || 0), 0)}
                                                </td>
                                                <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>{getDate.reduce((acc, item) => acc + item.SRate, 0)}</td>
                                                <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>
                                                    {getDate.reduce((acc, item, idx) => acc + (parseFloat(RateAfterDis[idx]) || 0), 0).toFixed(2)}
                                                </td>
                                                {/* <td className="border-r text-right text-sm">{filteredDatatable.reduce((acc, item, idx) => acc + (RQuantities[idx] || 0), 0)}</td> */}
                                                <td className=" border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>

                                                    {getDate.reduce((acc, item, idx) => {
                                                        const weight = Number(item.Bagweight);
                                                        const qty = RQuantities[idx];
                                                        if (!isNaN(weight) && !isNaN(qty)) {
                                                            return acc + (weight * qty);
                                                        }
                                                        return acc;
                                                    }, 0)}
                                                </td>
                                                <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>
                                                    {getDate.reduce((acc, item, idx) => acc + parseFloat(taxableAmount(RateAfterDis[idx], item.GSTRate, RQuantities[idx], item.Bagweight)), 0).toFixed(2)}
                                                </td>
                                                <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>
                                                    {getDate.reduce((acc, item, idx) => acc + parseFloat(calculateGst(RateAfterDis[idx], item.GSTRate, RQuantities[idx], item.Bagweight)), 0).toFixed(2)}
                                                </td>
                                                <td className="px-4 py-2 border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}>
                                                    {getDate.reduce((acc, item, idx) => acc + parseFloat(calculateTotalAmount(RateAfterDis[idx], item.GSTRate, RQuantities[idx], item.Bagweight)), 0).toFixed(2)}
                                                </td>

                                                <td className="border-r text-right text-sm" style={{ backgroundColor: 'rgb(190 242 225)' }}></td>
                                            </tr>
                                        </tfoot>

                                    </table>
                                </div>

                            </TableContainer>
                        </div>
                    </CardContent>
                </div>

                {showModal && (
                    <Modal open={showModal} className={showModal ? 'notification-modal' : ''}>
                        <div className="fixed inset-0 flex items-start justify-center z-10 ">
                            <div className="bg-green-100  p-6 rounded-lg shadow-lg" style={{ width: '700px', maxHeight: '80vh', overflowY: 'auto', overflowX: 'auto' }}>
                                <div className="flex justify-end mt-2">
                                    <button className="close-button md:static md:mr-2" onClick={closeModal} style={{ marginTop: '-20px', color: 'black' }}>
                                        <Tooltip title="Close">
                                            <FaTimes />
                                        </Tooltip>
                                    </button>
                                </div>
                                <Card className="w-full sm:w-1/2 mb-4 rounded-lg shadow-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0)' }}>
                                    <CardContent>
                                        <div>

                                        </div>
                                        <div className='w-full mb-5' style={{ display: 'flex', flexWrap: 'wrap' }}>
                                            <input
                                                type="text"
                                                placeholder="Search by date (DD/MM/YYYY)"
                                                value={searchDate}
                                                onChange={(e) => {
                                                    setSearchDate(e.target.value);
                                                    handleSearch(e.target.value);
                                                }}
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline mb-2"
                                            />

                                        </div>
                                    </CardContent>
                                </Card>
                            </div>
                        </div>
                    </Modal>
                )}


            </div>
        </div>
    );
};

export default SaleReturnApprovalEdit;
